import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import getMovimentoTipo from "../queries/getMovimentoTipo";

export default function useGetMovimentoTipo() {
  const resultQuery = useQuery([`${URLS.MOVIMENTOS_TIPO_API}`],
    () => getMovimentoTipo());

  return resultQuery;
}
